module.exports = __webpack_public_path__ + "static/img/MITCHELL_JOHNSON.803844d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MITCHELL_JOHNSON.jpg
// module id = 2x28
// module chunks = 0